export default "__VITE_ASSET__B5A2ykwK__"